exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".uu5-bricks-tree-list {\n  list-style-type: none;\n  padding-left: 2em;\n}\n.uu5-bricks-tree.uu5-bricks-tree-list {\n  padding-left: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./bricks/tree-list.less
// module id = 281
// module chunks = 0